import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { getAllProjectsSummary } from "../../../api/projectApi";

const EditProjectSelect = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  const [options, setOptions] = useState([]);

  useEffect(() => {
    const loadProjects = async () => {
      try {
        setIsLoading(true);
        const projects = await getAllProjectsSummary();
        const opts = (projects || []).map((p) => ({
          value: p.id,
          label: `${p.code ? p.code + " — " : ""}${p.name || "Без названия"}`,
        }));
        setOptions(opts);
      } catch (e) {
        setError(e?.message || "Не удалось загрузить проекты");
      } finally {
        setIsLoading(false);
      }
    };
    loadProjects();
  }, []);

  return (
    <div style={{ maxWidth: 720, margin: "40px auto", padding: "0 16px" }}>
      <h2 style={{ marginBottom: 16 }}>Выберите проект для редактирования</h2>
      {error && (
        <div style={{ color: "red", marginBottom: 12 }}>{error}</div>
      )}
      <Select
        isLoading={isLoading}
        options={options}
        placeholder="Начните вводить название или шифр проекта..."
        onChange={(opt) => opt && navigate(`/projects/edit/${opt.value}`)}
        isClearable
      />
    </div>
  );
};

export default EditProjectSelect;


